import { Component } from '@angular/core';

@Component({
  selector: 'what-we-do-advocacy',
  templateUrl: './advocacy.component.html',
  styleUrls: ['./advocacy.component.css'],
})
export class AdvocacyComponent {}
